import React from 'react';
import p from '@Components/pc/page/style.module.css';
import s from './style.module.css';
import { URL } from '@Pages/url';
import { LargeHeading2 } from '@Components/large_heading_2/view';
import RecommendCourse from '@Components/recommend_course/view';
import { RecommendCourseItem, RecommendCoursePrefecture } from '@Pages/Detail/props';

type RecommendCourseListProps = {
    courses: RecommendCourseItem[];
    prefecture: RecommendCoursePrefecture;
};

export const RecommendCourseList = (props: RecommendCourseListProps) => {
    const { courses, prefecture } = props;

    return (
        <>
            {courses && courses.length ? (
                <div className={p.body}>
                    <div className={`${s.component} `}>
                        <LargeHeading2 title={`その他の${prefecture.name}のゴルフ場の会員権相場`} />
                        <div className={s.course_list}>
                            {courses.map((course) => {
                                return (
                                    <RecommendCourse
                                        courseId={course.id}
                                        key={course.id}
                                        courseImageUrl={course.imageUrl}
                                        courseName={course.name}
                                        prefecture={prefecture}
                                    />
                                );
                            })}
                        </div>
                        <div className={s.link}>
                            <a href={`${URL.COURSES}?prefecture_codes[]=${prefecture.code}`}>
                                {prefecture.name}のゴルフ場会員権相場を見る
                            </a>
                        </div>
                    </div>
                </div>
            ) : (
                ''
            )}
        </>
    );
};

export default RecommendCourseList;
